import { Component } from "@angular/core";
import { AppCommonModule } from "@app/components/app.common.module";
import { ClientFormModalWrapperComponent } from "@app/components/client-form-modal-wrapper/client-form-modal-wrapper.component";

@Component({
  selector: 'app-client-form-modal',
  standalone: true,
  imports: [AppCommonModule],
  templateUrl: './client-form-modal.component.html',
  styleUrl: './client-form-modal.component.scss'
})
export class ClientFormModalComponent extends ClientFormModalWrapperComponent {

}
